import React from "react"

import { times } from "shared/lib/times"
import { Skeleton } from "shared/ui/skeleton/Skeleton"

export interface LoadingRowsProps {
  loadingRows?: number
  LoadingRowRenderer?: React.ComponentType<{ index: number }>
}

function LoadingRowsComponent({
  loadingRows = 6,
  LoadingRowRenderer
}: LoadingRowsProps) {
  if (!LoadingRowRenderer) {
    return <Skeleton />
  }
  return (
    <>
      {times(loadingRows).map(num => (
        <LoadingRowRenderer key={num.toString()} index={num} />
      ))}
    </>
  )
}

export const LoadingRows = React.memo(LoadingRowsComponent)
